import { useContext, useEffect, useState } from 'react';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import FiltersDisplayContent from './FiltersDisplayContent';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useValidateCondition } from '../../hooks/useValidateCondition';
import { ScrollContainer } from 'foundations-components/transitional/components/ScrollContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FiltersDisplayViewer = () => {
  const [isValidated, setIsValidated] = useState(false);
  const {
    isLoadingViewerData,
    internalDraftValue,
    dispatch
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    validateLogicGroup
  } = useValidateCondition();
  useEffect(() => {
    if (!isLoadingViewerData && internalDraftValue && !isValidated) {
      dispatch({
        type: 'internalDraftValue',
        payload: validateLogicGroup(internalDraftValue)
      });
      setIsValidated(true);
    }
  }, [isLoadingViewerData, internalDraftValue, validateLogicGroup, dispatch, isValidated]);
  if (!isLoadingViewerData && (!internalDraftValue || !isValidated)) {
    return null;
  }
  return /*#__PURE__*/_jsxs(ScrollContainer, {
    "data-test-id": "fr-viewer",
    id: "cdf-viewer-scrolling-container",
    children: [isLoadingViewerData && /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true,
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "newCustomerDataFilters.general.loadingFilters"
      }),
      showLabel: true,
      size: "small"
    }), !isLoadingViewerData && /*#__PURE__*/_jsx(FiltersDisplayContent, {})]
  });
};
export default FiltersDisplayViewer;